/**
 * Highlights the first occurrence of a search string within a given text by wrapping it in a `<strong>` tag.
 *
 * @param text - The text to search within.
 * @param search - The search string to highlight. Leading and trailing whitespace will be trimmed.
 * @returns A JSX element with the matched substring wrapped in `<strong>`, or the original text if no match is found or the search string is empty.
 */
export const highlightMatch = (text: string, search: string): JSX.Element => {
  const trimmedSearch = search.trim();
  if (!trimmedSearch) return <>{text}</>;

  const lowerText = text.toLowerCase();
  const lowerSearch = trimmedSearch.toLowerCase();
  const index = lowerText.indexOf(lowerSearch);

  if (index === -1) return <>{text}</>;

  const before = text.slice(0, index);
  const match = text.slice(index, index + trimmedSearch.length);
  const after = text.slice(index + trimmedSearch.length);

  return (
    <>
      {before}
      <strong>{match}</strong>
      {after}
    </>
  );
};
